export default __webpack_public_path__ + "static/media/vatar.21519c3b.png";